import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import AnalysisUISkeleton from 'analysis-tool/ui/AnalysisUISkeleton';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import AnalysisTabState from './AnalysisTabState';

export default class AnalysisTabView extends Backbone.View<AnalysisTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  render(): this {
    renderToDOM(
      <AnalysisUISkeleton
        analysisId={this.model.get('analysisId')}
        clientStateId={this.model.get('analysisId')}
      />,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<AnalysisTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

AnalysisTabView.initClass();
